import { css } from "../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      display: "flex",
      justifyContent: "center",
      gap: "baseUnit.mobile1",
      desktop: {
        gap: "baseUnit.mobile2",
      },
    }),
};
